import { render, staticRenderFns } from "./recebimento-monitor.vue?vue&type=template&id=caf02b80&scoped=true"
import script from "./recebimento-monitor.vue?vue&type=script&lang=ts"
export * from "./recebimento-monitor.vue?vue&type=script&lang=ts"
import style0 from "./recebimento-monitor.vue?vue&type=style&index=0&id=caf02b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf02b80",
  null
  
)

export default component.exports